<template>

  <t-page>

    <t-page-general :current-page="currentPage">

      <template #title-buttons>

        <b-link class="btn btn-outline-secondary mr-4" href="https://custom.onlaine.com.br/dashboard/custom/polimix/dashboard_polimix_orientacoes.html"  target="_blank">
          <b-icon-info-square class="mr-2"/>
          Orientações
        </b-link>

        <t-button primary @click="exportXlsx">
          <b-icon-file-earmark-excel-fill class="mr-2"/>
          Exportar para Excel
        </t-button>

      </template>

      <!-- Totalizador em destaque -->
      <b-alert v-if="pageListIsLoaded" show variant="warning" class="shadow-lg py-3">
        <div class="d-flex flex-column flex-md-row align-items-md-end justify-content-between">
          <div>
            <div class="text-uppercase small mb-1 font-weight-bold">Peso total (kg)</div>
            <div class="display-4 line-height-1">{{ totalWeight.toLocaleString('pt-BR') }}</div>
          </div>
          <div class="mt-3 mt-md-0 text-md-right">
            <div class="text-uppercase small mb-1 font-weight-bold">Produtos encontrados</div>
            <div class="display-4 line-height-1">
              {{ filteredItems.length }}
            </div>
          </div>
        </div>
      </b-alert>

      <b-container fluid class="py-3">

        <b-table
            v-if="pageListIsLoaded"
            :items="filteredItems"
            :fields="fields"
            thead-class="thead-light"
            table-class="table-fixed-header"
            small
            hover
            striped
            bordered
            head-variant="light"
            responsive="md"
        >
          <!-- Linha de filtros acima do cabeçalho -->
          <template #thead-top>
            <tr>
              <th v-for="f in fields" :key="'filter-'+f.key">

                <t-help v-if="objValid(f.help)" :title="f.help"></t-help>

                <!-- TEXT -->
                <b-form-input
                    v-if="!f.filterType || f.filterType === 'text'"
                    v-model="filters[f.key]"
                    @input="onFiltersChanged"
                    size="sm"
                    :placeholder="`Filtrar ${f.label}`"
                />
                <!-- NUMBER -->
                <b-form-input
                    v-else-if="f.filterType === 'number'"
                    v-model="filters[f.key]"
                    @input="onFiltersChanged"
                    size="sm"
                    type="number"
                    :placeholder="`Filtrar ${f.label}`"
                />
                <!-- DATE -->
                <b-form-input
                    v-else-if="f.filterType === 'date'"
                    v-model="filters[f.key]"
                    @input="onFiltersChanged"
                    size="sm"
                    type="date"
                    :placeholder="`Filtrar ${f.label}`"
                />


                <!-- SELECT (para Restrição e Expedição) -->
                <b-form-select
                    v-else-if="f.filterType === 'select'"
                    v-model="filters[f.key]"
                    @change="onFiltersChanged"
                    size="sm"
                    :options="getSelectOptions(f.key)"
                ></b-form-select>
                <!-- RANGE NUMBER (Peso) -->
                <b-input-group
                    v-else-if="f.filterType === 'range-number'"
                    size="sm"
                    class="align-items-center"
                >
                  <b-form-input
                      v-model="filters.totalProducedWeightMin"
                      @input="onFiltersChanged"
                      type="number"
                      placeholder="Mín"
                      min="0"
                      style="max-width:80px; min-width: 80px"
                  />
                  <b-input-group-text style="padding:0 4px;">–</b-input-group-text>
                  <b-form-input
                      v-model="filters.totalProducedWeightMax"
                      @input="onFiltersChanged"
                      type="number"
                      placeholder="Máx"
                      style="max-width:80px; min-width: 80px"
                      min="0"
                  />
                </b-input-group>


              </th>
            </tr>
          </template>


          <!-- Formatações de células -->
          <template #cell(totalProducedWeight)="{ item }">
            {{ (item.totalProducedWeight || 0).toLocaleString('pt-BR') }}
          </template>

          <template #cell(productionOrderCodeLabel)="{ item }">
            <!-- mostra a data crua (YYYY-MM-DD) do JSON; ajuste se quiser BR -->
            <a :href="'/custom/production/order/'+item.productionOrderNumber" target="_blank">
              {{ item.productionOrderCodeLabel }}</a>

          </template>


          <template #cell(issueDate)="{ item }">
            <!-- mostra a data crua (YYYY-MM-DD) do JSON; ajuste se quiser BR -->
            {{ item.issueDate | date }}
          </template>

          <template #cell(typeNonConformance)="{ item }">
            {{ normalizeText(item, 'typeNonConformance') }}
          </template>


        </b-table>
      </b-container>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import * as XLSX from 'xlsx';

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'PolimixProductionStockDetail',
  data() {
    return {
      path: "production/order/stock-unique-batch-detail/polimix-andamento/", //Utilizar somente quando fora do padrão
      generalResource: true,
      form: {
        unit: "",
        groupProduct: "",
        model: "",
        productionOrderCodeLabel: ""

      },
      fields: [
        {key: 'groupProduct', label: 'Grupo', filterType: 'select'},
        {key: 'model', label: 'Modelo', filterType: 'select'},
        {key: 'unit', label: 'Unid.', filterType: 'select'},
        {key: 'productionOrderCodeLabel', label: 'OF', filterType: 'text'},
        {key: 'totalProducedWeight', label: 'Peso (kg)', filterType: 'range-number', class: 'text-right'},
        {key: 'issueDate', label: 'Data Produzido', filterType: 'date', help: 'O tempo de quarentena é contado a partir do inicio da etapa e terá duração de 4320 minutos ou 3 dias completos. Para conferir o tempo decorrido clique no link da OF, depois no conta direito clique em Detalhar a etapa da Quarentena'},
        {key: 'processFlow', label: 'Fluxo', filterType: 'select'},
        {key: 'statusProduction', label: 'Status Operacional', filterType: 'select'},
        {key: 'typeRestriction', label: 'Restrição', filterType: 'select'},
        {key: 'note', label: 'Obs.', filterType: 'text'},
        {key: 'tolerances', label: 'Tolerâncias', filterType: 'text'},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      items: [],
      filters: {
        groupProduct: '',
        model: '',
        unit: '',
        productionOrderCodeLabel: '',
        totalProducedWeightMin: '',
        totalProducedWeightMax: '',
        issueDate: '',
        typeRestriction: '',
        typeNonConformance: '',
        material: '',
        processFlow: '',
        statusProduction: '',
        note: '',
      },
      debounceTimer: null,

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.currentPage.pageTitle = "Extrato de Produtos na Quarentena"

    },
    async mountedContinued() {

      this.pageListIsLoaded = true;
      this.applyFiltersFromQuery();

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    /** Dispara quando qualquer filtro muda (com debounce) */
    onFiltersChanged() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.updateQueryString();
      }, 300);
    },

    /** Lê a querystring atual e injeta nos filtros */
    applyFiltersFromQuery() {
      const params = new URLSearchParams(window.location.search);
      Object.keys(this.filters).forEach((k) => {
        if (params.has(k)) {
          // preserva valores em branco se vierem
          this.$set(this.filters, k, params.get(k));
        }
      });
    },

    /** Escreve os filtros atuais na querystring (sem recarregar a página) */
    updateQueryString() {
      const params = new URLSearchParams();
      Object.entries(this.filters).forEach(([k, v]) => {
        if (v !== null && v !== undefined && String(v).trim() !== '') {
          params.set(k, String(v).trim());
        }
      });

      const qs = params.toString();
      const newUrl = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;

      // Usa pushState para permitir "voltar"; troque por replaceState se quiser sobrescrever
      window.history.pushState({filters: this.filters}, '', newUrl);

    },

    /** Normaliza "typeNonConformance" a partir do objeto (cobre vários formatos) */
    normalizeText(item, field) {
      // se existir item.typeNonConformance (string), usa; senão, map por id; senão, '—'
      if (item[field] != null && String(item[field]).trim() !== '') {
        return item[field];
      }
      if (typeof item[field] === 'number') {
        // mapeamento simples (ajuste conforme sua regra de negócio)
        const map = {
          0: '—',            // sem restrição
        };
        return map[item[field]] != null ? map[item[field]] : `ID ${item[field]}`;
      }
      return '—';
    },


    /** Utilitário: normaliza string para busca (lowercase + remove acento) */
    _normalize(s) {
      return s
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
    },

    getSelectOptions(key) {
      const includeNone = ['typeNonConformance', 'typeRestriction'].includes(key);
      let values = [];

      if (key === 'typeNonConformance') {
        values = this.items.map(i => this.normalizeText(i, 'typeNonConformance'));
      } else if (key === 'typeRestriction') {
        values = this.items.map(i => this.normalizeText(i, 'typeRestriction'));
      } else if (key === 'material') {
        values = this.items.map(i => this.normalizeText(i, 'material'));
      } else if (key === 'processFlow') {
        values = this.items.map(i => this.normalizeText(i, 'processFlow'));
      } else if (key === 'statusProduction') {
        values = this.items.map(i => this.normalizeText(i, 'statusProduction'));
      } else if (key === 'groupProduct') {
        values = this.items.map(i => i.groupProduct);
      } else if (key === 'model') {
        values = this.items.map(i => i.model);
      } else if (key === 'unit') {
        values = this.items.map(i => i.unit);
      }

      // normaliza para string e remove vazios/—/nulos
      const cleaned = values
          .map(v => v == null || (v === 0 && key === 'expeditionNumber') ? '' : String(v).trim())
          .filter(v => v !== '' && v !== '—');

      const uniques = Array.from(new Set(cleaned))
          .sort((a, b) => a.localeCompare(b, 'pt-BR'));

      const options = [{value: '', text: 'Todos'}];
      if (includeNone) options.push({value: '__NONE__', text: 'Nenhuma'});
      if (key === 'expeditionNumber') options.push({value: '0', text: 'Nenhuma'});

      return options.concat(uniques.map(v => ({value: v, text: v})));
    },

    async exportXlsx() {
      try {
        if (!XLSX) {
          this.$bvToast && this.$bvToast.toast('Biblioteca XLSX não carregada.', {variant: 'danger'});
          return;
        }

        // 1) Dados já filtrados -> linhas planas na ordem solicitada
        const rows = this.filteredItems.map(it => ({
          groupProduct: it.groupProduct || '',
          model: it.model || '',
          unit: it.unit || '',
          productionOrderCodeLabel: it.productionOrderCodeLabel || '',
          totalProducedWeight: Number(it.totalProducedWeight) || 0,
          issueDate: it.issueDate ? it.issueDate.split('-').reverse().join('/') : '',
          material: this.normalizeText(it, 'material') || '',
          processFlow: this.normalizeText(it, 'processFlow') || '',
          statusProduction: this.normalizeText(it, 'statusProduction') || '',
          typeRestriction: this.normalizeText(it, 'typeRestriction') || '',
          typeNonConformance: this.normalizeText(it, 'typeNonConformance') || '',
          note: it.note || '',
          tolerances:  it.tolerances || '',
        }));

        // 2) Cabeçalho com rótulos amigáveis
        const header = [
          'Grupo', 'Modelo', 'Unid.', 'OF', 'Peso (kg)', 'Data Emissão', 'Material', 'Fluxo', 'Status Operacional', 'Restrição', 'Não Conformidade', 'Obs.', 'Tolerâncias'
        ];

        // 3) Cria WS só com o cabeçalho em A1
        const ws = XLSX.utils.aoa_to_sheet([header]);

        // 4) Adiciona os dados a partir de A2 (mantendo a ordem das props)
        XLSX.utils.sheet_add_json(ws, rows, {
          origin: 'A2',
          header: [
            'groupProduct', 'model', 'unit', 'productionOrderCodeLabel',
            'totalProducedWeight', 'issueDate', 'processFlow', 'statusProduction', 'typeRestriction', 'typeNonConformance', 'note', 'tolerances'
          ],
          skipHeader: true
        });

// 5) Linhas para total
        const dataStartRow = 2;                    // primeira linha de dados
        const dataEndRow = rows.length + 1;      // última linha de dados
        const totalRow = dataEndRow + 1;

        // linha "Total"
        XLSX.utils.sheet_add_aoa(ws, [['Total', '', '', '', 0, '', '', '', '', '', '', '']], {origin: `A${totalRow}`});

        // 👉 quantidade de itens na coluna D
        ws[`D${totalRow}`] = {f: `ROWS(D${dataStartRow}:D${dataEndRow})`}; // ou: `COUNTA(D${dataStartRow}:D${dataEndRow})`
        ws[`D${totalRow}`].z = '0'; // formatação inteira

        // soma do peso na coluna E
        ws[`E${totalRow}`] = {f: `SUM(E${dataStartRow}:E${dataEndRow})`};
        ws[`E${totalRow}`].z = '#,##0';

// 6) Larguras e formatação (opcional)
        ws['!cols'] = [
          {wch: 12}, {wch: 14}, {wch: 6}, {wch: 12},
          {wch: 12}, {wch: 12}, {wch: 14}, {wch: 12}, {wch: 12},
        ];
        for (let r = dataStartRow; r <= totalRow; r++) {
          const cell = ws[`E${r}`];
          if (cell) cell.z = '#,##0';
        }

        // 8) Workbook e download
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Estoque');
        const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
        XLSX.writeFile(wb, `estoque_filtrado_${stamp}.xlsx`);

      } catch (e) {
        console.error(e);
        this.$bvToast && this.$bvToast.toast('Falha ao gerar XLSX.', {variant: 'danger'});
      }
    },


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await crudGeneral.get(this.path)
        .then(response => {

          this.items = response.data
          this.pageListIsLoaded = true
          this.setIsLoadingPage(false)

        })
        .catch(error => {
          console.log('Erro externo: ' + error)
        })

    await this.mountedContinued()

  },

  computed: {
    // lista filtrada conforme os filtros atuais
    filteredItems() {
      const f = this.filters;
      return this.items.filter((row) => {


        // util: checa faixa [min,max]; strings vazias não restringem
        const inRange = (val, minStr, maxStr) => {
          const v = Number(val) || 0;
          const hasMin = String(minStr).trim() !== '';
          const hasMax = String(maxStr).trim() !== '';
          const min = hasMin ? Number(String(minStr).replace(',', '.')) : null;
          const max = hasMax ? Number(String(maxStr).replace(',', '.')) : null;
          const okMin = hasMin ? v >= (isNaN(min) ? -Infinity : min) : true;
          const okMax = hasMax ? v <= (isNaN(max) ? Infinity : max) : true;
          return okMin && okMax;
        };

        // texto => "contém", case-insensitive, ignora acento
        const textMatch = (val, needle) => {
          if (!needle) return true;
          return this._normalize(String(val)).includes(this._normalize(String(needle)));
        };

        // number => aceita número exato OU >= quando for sufixado com "+"


        // date (ISO yyyy-mm-dd) => aceita:
        // - exata: 2024-12-12
        // - intervalo: 2024-12-01..2024-12-31
        const dateMatch = (valIso, needle) => {
          if (!needle) return true;
          if (!valIso) return false;

          const toDate = (s) => new Date(s + 'T00:00:00');
          if (needle.includes('..')) {
            const [start, end] = needle.split('..').map(s => s.trim());
            const d = toDate(valIso);
            const okStart = start ? d >= toDate(start) : true;
            const okEnd = end ? d <= toDate(end) : true;
            return okStart && okEnd;
          }
          return valIso === needle;
        };


        // campos existentes no JSON
        const eqSel = (val, sel) => !sel ? true : this._normalize(String(val)) === this._normalize(String(sel));
        // agora usa igualdade ao invés de "contains"
        const okGroup = eqSel(row.groupProduct, f.groupProduct);
        const okModel = eqSel(row.model, f.model);
        const okUnit = eqSel(row.unit, f.unit);

        const okOF = textMatch(row.productionOrderCodeLabel, f.productionOrderCodeLabel);
        const okTolerance = textMatch(row.tolerances, f.tolerances);
        const okNote = textMatch(row.note, f.note);

        const okPeso = inRange(
            row.totalProducedWeight || 0,
            f.totalProducedWeightMin,
            f.totalProducedWeightMax
        );
        const okIssue = dateMatch(row.issueDate, f.issueDate);

        const normalizeValue = (v) => {
          const s = v == null ? '' : String(v).trim();
          return (s === '' || s === '—') ? '__NONE__' : s;  // sempre string
        };

        // Restrição
        const restrValue = normalizeValue(this.normalizeText(row, 'typeRestriction'));
        const okRestr = !f.typeRestriction
            ? true
            : f.typeRestriction === '__NONE__'
                ? restrValue === '__NONE__'
                : restrValue === f.typeRestriction;

        // Não Conformidade
        const nonConfValue = normalizeValue(this.normalizeText(row, 'typeNonConformance'));
        const okNonConf = !f.typeNonConformance
            ? true
            : f.typeNonConformance === '__NONE__'
                ? nonConfValue === '__NONE__'
                : nonConfValue === f.typeNonConformance;


        // material
        const materialValue = normalizeValue(this.normalizeText(row, 'material'));
        const okMaterial = !f.material
            ? true
            : f.material === '__NONE__'
                ? materialValue === '__NONE__'
                : materialValue === f.material;


        // processFlow
        const processFlowValue = normalizeValue(this.normalizeText(row, 'processFlow'));
        const okProcessFlowValue = !f.processFlow
            ? true
            : f.processFlow === '__NONE__'
                ? processFlowValue === '__NONE__'
                : processFlowValue === f.processFlow;


        //statusProduction
        const statusProductionValue = normalizeValue(this.normalizeText(row, 'statusProduction'));
        const okStepCurrentName = !f.statusProduction
            ? true
            : f.statusProduction === '__NONE__'
                ? statusProductionValue === '__NONE__'
                : statusProductionValue === f.statusProduction;

        return okGroup && okModel && okUnit && okOF && okTolerance && okNote && okPeso && okIssue && okRestr && okNonConf && okMaterial && okProcessFlowValue && okStepCurrentName;
      });
    },

    // soma do peso dos itens filtrados
    totalWeight() {
      return this.filteredItems.reduce((sum, r) => sum + (Number(r.totalProducedWeight) || 0), 0);
    },

  }
}
</script>
<style>
/* ambos sticky: filtros (linha 1) e cabeçalho (linha 2) */
.table-fixed-header {
  --sticky-top: 60px;
  --filter-height: 38px;
}

.table-fixed-header thead tr:nth-child(1) th {
  position: sticky;
  top: var(--sticky-top);
  z-index: 6;
  background: #f8f9fa;
}

.table-fixed-header thead tr:nth-child(2) th {
  position: sticky;
  top: calc(var(--sticky-top) + var(--filter-height));
  z-index: 5;
  background: #f8f9fa;
}

</style>